import type { SCCodeEditorAndFragmentProps } from '../code';
import { SCCodeEditorAndFragment } from '../code';
import { SCFormLabel } from '../form';
import { SCView } from '../view';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';

interface SCFormFieldSCCodeEditorAndFragmentProps
  extends SCFormFieldProps, Omit<SCCodeEditorAndFragmentProps, 'value' | 'onChange'> {
  hasEditor?: boolean;
  maxHeight?: string | number; // Maximum height for the editor
}

function SCFormFieldSCCodeEditorAndFragment({
  label,
  name,
  required,
  disabled,
  rules,
  actionButtons,
  hasEditor = true,
  defaultValue,
  maxHeight = 600,
  ...rest
}: SCFormFieldSCCodeEditorAndFragmentProps) {
  return (
    <SCFormField
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      rules={rules}
      withMarginBottom
      defaultValue={defaultValue}
    >
      {({ field, extraProps }) => {
        // Description: display action buttons as standalone highlighting if hasEditor=false
        const isActionStandalone = !hasEditor;

        const editorLabel = label ? (
          <SCFormLabel
            label={label}
            required={required}
            actionButtons={isActionStandalone || actionButtons}
            // Note: same as Tooltip feature implemented in eone-ui/form-input
            Tooltip={extraProps?.Tooltip}
          />
        ) : undefined;

        return (
          <>
            {hasEditor ? (
              <SCView
                //h={maxHeight ? undefined : '600px'}
                className="sc-code-editor-containersss"
                //style={{
                //	maxHeight: maxHeight,
                //	overflow: maxHeight ? 'hidden' : undefined,
                //}}
              >
                <SCCodeEditorAndFragment
                  value={field.value}
                  onChange={field.onChange}
                  {...rest}
                  editorTitle={editorLabel}
                  disabled={field.disabled}
                  maxHeight={maxHeight}
                  {...extraProps}
                />
              </SCView>
            ) : null}
            {isActionStandalone ? (
              <div className="sc-form-field-code-editor-action-standalone">{actionButtons}</div>
            ) : null}
          </>
        );
      }}
    </SCFormField>
  );
}

export { SCFormFieldSCCodeEditorAndFragment };
export type { SCFormFieldSCCodeEditorAndFragmentProps };
